import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/logo-studmin.png';
import '../assets/styles/Connexion.css';

/**
 * Page de connexion à la gestion interne. Hors du châssis (pas de barre
 * latérale) : tant qu'on n'est pas connecté, il n'y a rien à naviguer.
 */
function Connexion() {
  const { utilisateur, chargement, connecter } = useAuth();
  const location = useLocation();

  const [identifiant, setIdentifiant] = useState('');
  const [motDePasse, setMotDePasse] = useState('');
  const [voir, setVoir] = useState(false);
  const [erreur, setErreur] = useState(null);
  const [envoi, setEnvoi] = useState(false);

  // Page demandée avant la redirection (cf. RequireAuth), sinon l'accueil.
  const de = location.state?.de;
  const destination = de && !de.startsWith('/connexion') ? de : '/';

  if (chargement) return <div className="connexion-attente">Chargement…</div>;
  if (utilisateur) return <Navigate to={destination} replace />;

  async function soumettre(e) {
    e.preventDefault();
    setErreur(null);
    setEnvoi(true);
    try {
      // Le contexte passe `utilisateur` : le rendu suivant redirige.
      await connecter(identifiant, motDePasse);
    } catch (err) {
      setErreur(err.message || 'Connexion impossible.');
      setEnvoi(false);
    }
  }

  return (
    <div className="connexion-page">
      <form className="connexion-carte" onSubmit={soumettre}>
        <div className="connexion-marque">
          <img className="connexion-logo" src={logo} alt="Studmin" />
          <div className="connexion-marque-sous">GESTION INTERNE · ECHO CSE</div>
        </div>

        <h1 className="connexion-titre">Connexion</h1>
        <p className="connexion-note">
          Accès réservé à l&apos;équipe. Entrez votre identifiant ou votre adresse email.
        </p>

        <label className="connexion-champ">
          <span>Identifiant ou email</span>
          <input
            type="text"
            name="identifiant"
            autoComplete="username"
            autoFocus
            value={identifiant}
            onChange={(e) => setIdentifiant(e.target.value)}
            disabled={envoi}
            required
          />
        </label>

        <label className="connexion-champ">
          <span>Mot de passe</span>
          <div className="connexion-mdp">
            <input
              type={voir ? 'text' : 'password'}
              name="motDePasse"
              autoComplete="current-password"
              value={motDePasse}
              onChange={(e) => setMotDePasse(e.target.value)}
              disabled={envoi}
              required
            />
            <button
              type="button"
              className="connexion-oeil"
              onClick={() => setVoir((v) => !v)}
              aria-label={voir ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
            >
              {voir ? 'Masquer' : 'Afficher'}
            </button>
          </div>
        </label>

        {erreur && (
          <div className="connexion-erreur" role="alert">
            {erreur}
          </div>
        )}

        <button type="submit" className="connexion-bouton" disabled={envoi}>
          {envoi ? 'Connexion' : 'Se connecter'}
        </button>
      </form>
    </div>
  );
}

export default Connexion;
